module.exports = __webpack_public_path__ + "media/faq/hero-f719e598.jpg";